import { ObjectMapper } from 'json-object-mapper';
import { Model, OptionModel } from '../model';
import { IModel } from '../IModel';

export class JobTitleSeniorizationModel extends Model implements IModel<JobTitleSeniorizationModel> {
  companyGroupId: string | undefined = undefined;
  name: string = '';
  description: string = '';
  level: number | undefined = undefined;
  foreignId: string | undefined = undefined;
  jobTitles: any[] | undefined = undefined;

  static create(input: any): JobTitleSeniorizationModel {
    return ObjectMapper.deserialize<JobTitleSeniorizationModel>(JobTitleSeniorizationModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }

  toOption(): OptionModel {
    return { label: `${this.name}`, value: this.id } as OptionModel;
  }
}